// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hJyQN","newExpiryDate":"styles_newExpiryDate__IlKDJ","footer":"styles_footer__Lvq2L"};